import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ModalDialogMixin } from '../../mixins/components/ModalDialogMixin';
import CustomPropTypes from '../../util/custom-prop-types';
import Modal from '../Modal/Modal';
import { MODAL_SIZES } from '../../constants';
import { getSize } from './getSize';
export var StyledModalDialog = /*#__PURE__*/styled(Modal).withConfig({
  displayName: "StyledModalDialog",
  componentId: "c11n-8-81-1__sc-ify1vj-0"
})(["", ""], ModalDialogMixin);
/**
 * A modal dialog component, also commonly know simply as a "modal" or a "lightbox".
 *
 * All props are passed to the underlying [`Dialog`](#/Dialog%20components?id=dialog) component.
 * See [`Dialog`](#/Dialog%20components?id=dialog) for additional documentation.
 *
 * ##### Known Limitations
 * * In IE11, dialogs always take up the full height of the screen.
 */

var ModalDialog = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledModalDialog, _extends({
    "aria-modal": "true",
    ref: ref
  }, props, {
    size: getSize(props)
  }));
});
ModalDialog.displayName = 'ModalDialog';
ModalDialog.propTypes = {
  /**
   * Display divider lines between header, body, and footer sections.
   *
   * @since 8.54.0
   */
  dividers: PropTypes.bool,

  /**
   * By default, when there is overflow content in the dialog body, the body will scroll within
   * the dialog bounds. Optionally, you can disable scrolling on the dialog body and instead
   * have the entire dialog scroll within the document bounds.
   */
  scrollDocument: PropTypes.bool,

  /**
   * The size of a modal dialog.
   *
   * Supports [inline media query objects](#/Media%20queries)
   *
   * @since 8.54.0
   */
  size: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.values(MODAL_SIZES))),

  /**
   * @deprecated Use the `size="fullScreen"` prop.
   */
  fullScreen: CustomPropTypes.inlineMediaQuery(PropTypes.bool),

  /**
   * @deprecated Use the `size="md"` prop.
   */
  wide: PropTypes.bool,

  /**
   * @deprecated Use [inline media query objects](#/Media%20queries)
   */
  mediaQuery: CustomPropTypes.mediaQuery
};
ModalDialog.defaultProps = {
  dividers: true,
  fullScreen: false,
  size: MODAL_SIZES.XS,
  wide: false,
  scrollDocument: false
};
ModalDialog.SIZES = MODAL_SIZES;
export default ModalDialog;